export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6163.78dff68d.jpg";